export const BATCH_SHIPMENT_SUCCESS = "BATCH_SHIPMENT_SUCCESS";
export const BATCH_SHIPMENT_REQUEST = "BATCH_SHIPMENT_REQUEST";
export const BATCH_SHIPMENT_FAILURE = "BATCH_SHIPMENT_FAILURE";
export const BATCH_SHIPMENT_RESET = "BATCH_SHIPMENT_RESET";
export const batchShipmentSuccess = (payload) => ({
    type: BATCH_SHIPMENT_SUCCESS,
    payload,
});
export const batchShipmentRequest = (payload) => ({
    type: BATCH_SHIPMENT_REQUEST,
    payload,
});
export const batchShipmentFailure = (payload) => ({
    type: BATCH_SHIPMENT_FAILURE,
    payload,
});
export const batchShipmentRest = () => ({
    type: BATCH_SHIPMENT_RESET,
});
